import '@emotion/react';

import type { ThemeOptions } from '@mui/material';

export const muiThemes: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
};
